import { db, func } from '@/main'

export default {
  namespaced: true,
  state: {
    employees: [],
    loading: false,
    error: null,
    branch: ''
  },
  mutations: {
    filterBranch(state, payload) {
      state.branch = payload
    },
    employees(state, payload) {
      state.employees = payload || []
    },
    error(state, payload) {
      state.error = payload
    },
    startAction(state) {
      state.error = null
      state.loading = true
    },
    stopAction(state) {
      state.loading = false
    }
  },
  actions: {
    /**
     * @func
     * @desc query all current tenant employees
     *   by using onSnapshot listener
     *   this function will also be invoked automatically if there is any changes at remote
     *   so you don't have to update any client side store
     * @param [context]
     */
    subscribeEmployee(context) {
      db.collection('users')
        .where('tenantId', '==', context.rootState.account.tenantId)
        .onSnapshot((querySnapshot) => {
          const employees = []
          querySnapshot.forEach((snapshot) => {
            const data = snapshot.data()
            data.documentId = snapshot.id
            if (!data.branchId) {
              data.branchId = ''
            }
            employees.push(data)
          })
          console.log('employees coming', employees)
          context.commit('employees', employees)
        })
    },
    createEmployee(context, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          name: payload.empName,
          phone: payload.phoneNumber,
          tenantId: context.rootState.account.tenantId,
          branchId: payload.branch,
          role: payload.role
        }
        const callCreateEmployee = func.httpsCallable('callCreateEmployee')
        callCreateEmployee(body)
          .then((result) => {
            return resolve(result)
          })
          .catch((error) => {
            return reject(error)
          })
      })
    }
  },
  getters: {
    countEmployees(state) {
      if (!state.employees || state.employees.length < 1) {
        return 0
      }
      return state.employees.length
    },
    employeeAdminOrOwner(state) {
      const admin = state.employees.filter((x) => {
        const takeBranch = state.branch || false
        if (takeBranch) {
          return x.branchId.includes(state.branch)
        }
        return true
      })
      return admin.filter((x) =>
        ['admin', 'owner'].includes(x.role.toLowerCase())
      )
    },
    employeeSales(state) {
      const sale = state.employees.filter((x) => {
        const takeBranch = state.branch || false
        if (takeBranch) {
          return x.branchId.includes(state.branch)
        }
        return true
      })
      return sale.filter((x) => ['sale'].includes(x.role.toLowerCase()))
    }
  }
}
